<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!role">
      <span class="loader"></span>
    </span>
    <role-form
      v-if="role && !loading"
      :loading="loading"
      :roleData="role"
      :formErrors="formErrors"
      @roleSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import RoleForm from "../partials/RoleForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultRole from "../defaultRole";

export default {
  layout: "DashboardLayout",

  components: { RoleForm },

  mixins: [alertLeave],

  props: {
    roleId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      role: cloneDeep(defaultRole),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("roles/get", this.roleId);
        this.role = this.$store.getters["roles/role"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(role) {
      this.loading = true;
      const roleData = cloneDeep(role);

      try {
        await this.$store.dispatch("roles/update", roleData);
        this.$notify({
          type: "success",
          message: this.$t("ROLES.ROLES_UPDATED"),
        });
        const role = await this.$store.getters["roles/role"];
        this.$emit("onViewRole", role, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
